module.exports = __webpack_public_path__ + "img/EC.b9978c08.png";